import { licenseGuard } from "../func"

const popupRouter = {
  path: "popup",
  component: {
    template: "<router-view></router-view>",
  },
  children: [
    {
      path: "manager",
      name: "popup-manager",
      component: () => import("@/components/dialogs/dialogManagerApply.vue"),
    },
    {
      path: "mobile_manager",
      name: "popup-mobile-manager",
      component: () => import("@/components/dialogs/dialogMobileManagerApply.vue"),
    },
    {
      path: "agent",
      name: "popup-agent",
      component: () => import("@/components/dialogs/dialogAgentApply.vue"),
    },
    {
      path: "status_check",
      name: "popup-status-check",
      component: () => import("@/components/dialogs/dialogLoginStatusCheck.vue"),
    }
  ],
}

export default popupRouter
